import type { IconIndicatorProps } from "../icon-indicator.type";
import type { PropsWithChildren } from "react";

import { Tooltip } from "@/ui/tooltip";

import { useIconIndicatorTooltip } from "./icon-indicator-tooltip.hook";

export const IconIndicatorTooltip = ({
  children,
  ...props
}: PropsWithChildren<IconIndicatorProps>) => {
  const tooltip = useIconIndicatorTooltip(props);

  return (
    <Tooltip
      title={
        typeof tooltip === "string" ? (
          tooltip
        ) : (
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            {tooltip.map((tooltipText) => (
              <li key={`indicator-tooltip-${tooltipText}`}>{tooltipText}</li>
            ))}
          </ul>
        )
      }
      placement="bottom"
    >
      {children}
    </Tooltip>
  );
};
